export default __webpack_public_path__ + "static/media/Visual_joil_24.ee12a4e2.jpg";